var currentTab = 0; // Current tab is set to be the first tab (0)
try{
    showTab(currentTab); // Display the current tab
}catch(err){
    
}


function showTab(n) {
  // This function will display the specified tab of the form ...
  var x = document.getElementsByClassName("tab");
  x[n].style.display = "block";
  // ... and fix the Previous/Next buttons:

  // ... and run a function that displays the correct step indicator:
  //fixStepIndicator(n)
}


function nextTab(n){
    var x = document.getElementsByClassName("tab");
    //x[currentTab].style.display = "none";
    
    $(x[currentTab]).slideUp('slow'); 
    
    currentTab = currentTab + n;
    showTab(currentTab);
    document.getElementById('step').innerHTML = currentTab+1;
    if(currentTab>1){
        document.getElementById("prev-button").style.display = "block";
    }else{
        document.getElementById("prev-button").style.display = "none";
    }
}


function prevTab(n){
    var x = document.getElementsByClassName("tab");
    x[currentTab].style.display = "none";
    currentTab = currentTab - n;
    showTab(currentTab);
    document.getElementById('step').innerHTML = currentTab + 1;
    
    if(currentTab<=1){
        document.getElementById("prev-button").style.display = "none";
    }  
    
}


function nextAndValidate(n){
    var valid = validateForm();
    if(valid!=false){
        nextTab(n);
    }
}


function fixStepIndicator(n) {
  // This function removes the "active" class of all steps...
  var i, x = document.getElementsByClassName("step");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  //... and adds the "active" class to the current step:
  x[n].className += " active";
    
    
}


function validateForm() {
  var x, y, i, valid = true;
  x = document.getElementsByClassName("tab");
  y = x[currentTab].getElementsByTagName("input");
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (y[i].value == "" & y[i].dataset.required=='true' & $(y[i]).is(":visible")) {
             
      // add an "invalid" class to the field:
      y[i].className += " invalid";
      // and set the current valid status to false:
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:

  return valid; // return the valid status
}


function selectRadio(id,current){
    
    selectRadioNoStep(id,current);
    nextTab(1);
    
}

function selectRadioNoStep(id,current){
    
    var x, y, i = true;
    x = document.getElementsByClassName("tab");
    y = x[currentTab].getElementsByClassName("active");
    
    for(i=0; i<y.length; i++){
        y[i].classList.remove("active");
    }
    
    var yi, ii = true;
    yi = x[currentTab].getElementsByTagName("input");
    for(ii=0; ii<yi.length; ii++){
        yi[ii].removeAttribute('checked');
    }
    
    //$('.active').removeClass('active');
    $(current).addClass('active');
    $('#'+id).attr('checked',true);
}

